module.exports = __webpack_public_path__ + "static/fanfare-df3a3336293c82ec1ae9cb8ac662ecc3.jpg";